import { CenterContentContainer, ContentHeaderView, PageContainer, PageContentView } from 'components/shared';
import React, { useEffect } from 'react';
import ExternalIframe from 'components/shared/containers/ExternalIframe';
import "./styles.css";
/**
 * @function CreditScorePage
 * @return {React.Component}
 * @exported true
 * @description The main component for CreditScorePage
 */
export default function CreditScorePage(props) {

  useEffect(() => {
    // If the demo is in a mobilew view (MABI23 included) execute this code 
    // that will make the page unscrollable  except for the iframe.
    if(window.innerWidth <= 625) {
      const creditScorePage = document.querySelector(".credit-score-page");
      creditScorePage.style.height = "100vh";
      creditScorePage.style.overflow = "hidden";
    }
  });
  
  return (
    <PageContainer className="credit-score-page integrated-product-page">
      <PageContentView>
        <CenterContentContainer>
          <ContentHeaderView text="Credit Score"/>
          <div className="iframe-container flex-container flex-horizontal justify-center">
            {/* iFrame for CS21 goes here */}
            <ExternalIframe demo="CS21" className="credit-score-iframe"  key ="CreditScorePage"/>
          </div>
        </CenterContentContainer>
      </PageContentView>
    </PageContainer>
  )
}
